
















import { Vue, Component } from 'vue-property-decorator'

interface TimelineElement {
  title: string;
  text: string;
}

@Component
export default class History extends Vue {
  private items: TimelineElement[] = [{
    title: '1993 Meisterprüfung',
    text: 'Reinhard Eble hat die Meisterprüfung erfolgreich bestanden'
  }, {
    title: '1997 Gründung',
    text: 'Übernahme Autohauses Tress & Zipperer und Umbenennung in Autohaus Eble'
  }, {
    title: '2008 Auszeichnung',
    text: 'Das Autohaus hat die Auszeichnung "Werkstatt des Vertrauens" erhalten'
  }, {
    title: '2009 Auszeichnung',
    text: 'Das Autohaus hat die Auszeichnung "Werkstatt des Vertrauens" erhalten'
  }, {
    title: '2020 Alleskönner',
    text: 'Services und Reparaturen für alle Marken und Modelle'
  }]

  private isEven (i: number) {
    return (i % 2 === 0)
  }
}
